import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getDefaultRedirectPath } from '../utils/redirectUtils';

/**
 * Component that redirects users to their default dashboard based on role
 */
const DashboardRedirect = () => {
  const { user, loading, isAuthenticated } = useAuth();
  const [redirectPath, setRedirectPath] = useState(null);

  useEffect(() => {
    // Wait for auth to be loaded before determining redirect
    if (!loading) {
      // If authenticated but no user data, try to get from localStorage
      let userToCheck = user;
      if (!userToCheck && isAuthenticated) {
        try {
          const storedUser = localStorage.getItem('user');
          if (storedUser) {
            userToCheck = typeof storedUser === 'string' ? JSON.parse(storedUser) : storedUser;
            // console.log('[DashboardRedirect] Retrieved user from localStorage:', userToCheck);
          }
        } catch (e) {
          // console.error('[DashboardRedirect] Failed to parse user from localStorage:', e);
        }
      }

      if (isAuthenticated && userToCheck) {
        const path = getDefaultRedirectPath(userToCheck);
        // console.log('[DashboardRedirect] Redirecting to:', path, { user: userToCheck });
        setRedirectPath(path);
      } else if (isAuthenticated && !userToCheck) {
        // Authenticated but no user data - default to My Queries
        // console.warn('[DashboardRedirect] Authenticated but no user data, redirecting to My Queries');
        setRedirectPath('/dashboard/queries/raise');
      }
      // If not authenticated, ProtectedRoute will handle redirect to login
    }
  }, [user, loading, isAuthenticated]);

  if (loading) {
    return null; // Will be handled by ProtectedRoute
  }

  if (!redirectPath) {
    return null; // Still determining redirect path
  }

  return <Navigate to={redirectPath} replace />;
};

export default DashboardRedirect;

